export default "__VITE_ASSET__COiZ1d_K__"